export default __webpack_public_path__ + "static/media/wave-blue.2de910b8.svg";